// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext} from 'react';
import cn from 'classnames';
// @ts-ignore
import {url2md5} from 'pub_config';
import {Button, i_button_props} from '../lib/button';
import {Link} from './link';
import {Settings_context} from '../settings_ctx';
import {use_translation_v} from '../lib/trans_v';
import styles from './cards.module.less';

export interface i_card {
    id: string;
    title: string | JSX.Element;
    text: string | JSX.Element;
    img?: string | JSX.Element;
    img_wrapper_cls?: string;
    btn?: i_button_props;
    to?: string;
    clickid?: string;
    new_tab?: boolean;
    on_click?: ()=>void;
}
export interface i_cls_obj {
    container?: string;
    cards_wrapper?: string;
    cards_spacer?: string;
    card?: string;
    title?: string;
    text?: string;
    img?: string;
}
interface i_cards_props {
    cards: i_card[];
    cls?: i_cls_obj;
    spacer?: JSX.Element;
}
export const Cards = (props:i_cards_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {cards, cls = {}, spacer} = props;
    return <div className={cn(styles.cards, cls.container)}>
      {cards.map((card_props, i)=>{
          const {id, title, text, img, btn, to, clickid, new_tab,
              img_wrapper_cls, on_click} = card_props;
          const img_content = typeof img == 'string' ?
              <img className={cn('lazyload', cls.img && cls.img)}
                alt={`How Hola VPN works: step ${i+1}`}
                data-src={url2md5(`/www/hola/pub/img/${img}`)}/> : img;
          const card_content = <Fragment>
            {img_content && <div className={cn(styles.img, cls.img,
              img_wrapper_cls && img_wrapper_cls)}>
              {img_content}
            </div>}
            <p className={cn(styles.title, cls.title)}><T>{title}</T></p>
            {text && <div className={cn(styles.text, theme.P, cls.text)}>
              <T>{text}</T></div>}
            {btn && <Button {...btn}/>}
          </Fragment>;
          return <Fragment key={id}>
            {to ? <Link to={to} className={cn(styles.card, cls.card)}
              data-clickid={clickid} data-id={id}
              target={new_tab ? '_blank' : undefined}
              rel={new_tab ? 'noopener noreferrer' : undefined}>
              {card_content}
            </Link> : <div className={cn(styles.card, cls.card,
              on_click && styles.pointer)} data-id={id} onClick={on_click}>
              {card_content}
            </div>}
            {i<cards.length-1 && spacer}
          </Fragment>;
      })}
    </div>;
};
